import { createReducer } from '@reduxjs/toolkit';
import { calculateOnboardingProgress } from 'utils/progressCalculation';

// error, warning, info, success

export const initialState = {
    progress: 0,
    completion: {

    },
    submitted: false,
    leadPreMeetingConfiguration: null // Store configuration for progress calculation
};

export const onboardingProgressReducer = createReducer(initialState, {
    LEAD_PROGRESS_CHANGE: (state, action) => {
        state.completion = {
            ...state.completion,
            ...action.payload.completion
        };
        
        // Only update submitted if explicitly provided, otherwise preserve existing value
        // This prevents other sections from accidentally resetting the submitted state
        if (typeof action.payload.submitted !== 'undefined') {
            state.submitted = action.payload.submitted;
        }
        
        // If configuration is provided, recalculate progress based on visible sections
        if (action.payload.leadPreMeetingConfiguration) {
            state.leadPreMeetingConfiguration = action.payload.leadPreMeetingConfiguration;
        }
        
        // Calculate progress based on visible sections only
        if (state.leadPreMeetingConfiguration) {
            state.progress = calculateOnboardingProgress(state.completion, state.leadPreMeetingConfiguration);
        } else {
            // Fallback to provided progress if no configuration
            state.progress = action.payload.progress || 0;
        }
    },
});
